import { createAction } from 'redux-actions';
import { createRequestActions } from '../utils';
import * as userTypes from './userTypes';

export const authenticate = createRequestActions(userTypes.AUTHENTICATE);
export const logout = createAction(userTypes.LOGOUT);
